// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ddv2","delete":"styles_delete__1uUwm","update":"styles_update__2JLOC","add":"styles_add__3X7ze"};